!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, o = {}, i = t.parcelRequire5f74;
  null == i && ((i = function(t) {
    if (t in e) return e[t].exports;
    if (t in o) {
      var i = o[t];
      delete o[t];
      var r = {
        id: t,
        exports: {}
      };
      return e[t] = r, i.call(r.exports, r, r.exports), r.exports;
    }
    var n = new Error("Cannot find module '" + t + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
  }).register = function(t, e) {
    o[t] = e;
  }, t.parcelRequire5f74 = i), (0, i.register)("kmbQD", function(t, e) {
    var o, i, r, n;
    o = t.exports, i = "default", r = function() {
      return a;
    }, Object.defineProperty(o, i, {
      get: r,
      set: n,
      enumerable: !0,
      configurable: !0
    });
    class a {
      static doChange({id: t, quantity: e, properties: o = {}}, i = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...o
            }
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, o = !1) {
        const i = Array.isArray(t) ? t.reduce((t, o) => ({
          ...t,
          [o]: e
        }), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: i
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && o && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: o = {}}, i = !1, r = !0) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...o
              }
            } ]
          })
        }).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok && r ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && i ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", o = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const i = document.getElementById("Cart"), r = !!t || i && i.checked;
        return fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, i] = t, n = (new DOMParser).parseFromString(i, "text/html");
            if (e.includes("cart-notification")) {
              const t = document.querySelector("cart-notification"), e = n.querySelector("cart-notification");
              t && e && (t.innerHTML = e.innerHTML);
            }
            o ??= [ `[id^="shopify-section-"][id$="${e}"]` ], o.push("header [data-cart-count-desktop]", "header [data-cart-count-mobile]", "form [data-cart-count]", "[data-cart-link]"), 
            o.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const o = n.querySelector(t);
                o && (e.innerHTML = r ? o.innerHTML.replace('id="Cart"', 'id="Cart" checked') : o.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var r = i("kmbQD");
  class n extends HTMLElement {
    constructor() {
      super(), this.favoriteElement = null, this.isTouchDevice = this.detectTouchDevice(), 
      this.touchStarted = !1, this.documentTouchHandler = null, this.touchStartTime = 0, 
      this.touchStartPos = {
        x: 0,
        y: 0
      }, this.isDragging = !1, this.tapThreshold = 150, this.dragThreshold = 10;
    }
    connectedCallback() {
      this.init(), this.setupVariantClickListeners(), this.setupTouchBehavior();
    }
    detectTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    init() {
      this.variants = this.querySelectorAll("[data-variant]"), this.favoriteElement = this.querySelector(".product-card__favourite");
    }
    setupVariantClickListeners() {
      this.variants.forEach(t => {
        t.addEventListener("click", e => {
          e.preventDefault(), e.stopPropagation();
          const o = t.dataset.id;
          t.hasAttribute("data-out-of-stock") ? this.showOutOfStockModal(o) : o && !t.hasAttribute("data-loading") && this.addToCart(o, t);
        });
      });
    }
    setupTouchBehavior() {
      this.isTouchDevice && (this.addEventListener("touchstart", this.handleTouchStart.bind(this), {
        passive: !0
      }), this.addEventListener("touchend", this.handleTouchEnd.bind(this)), this.addEventListener("touchmove", this.handleTouchMove.bind(this), {
        passive: !0
      }), this.favoriteElement && (this.documentTouchHandler = this.handleDocumentTouch.bind(this)));
    }
    handleTouchStart(t) {
      this.touchStarted = !0, this.touchStartTime = Date.now(), this.touchStartPos = {
        x: t.touches[0].clientX,
        y: t.touches[0].clientY
      }, this.isDragging = !1, this.favoriteElement && (this.showFavoriteButton(), document.addEventListener("touchstart", this.documentTouchHandler, {
        passive: !0
      }));
    }
    handleTouchEnd(t) {
      this.touchStarted = !1;
      const e = Date.now() - this.touchStartTime, o = t.target;
      if (!(o.closest("[data-variant]") || o.closest("[data-media-controls]") || o.closest(".product-card__favourite") || o.closest("quick-add-modal")) && !this.isDragging && e < this.tapThreshold) {
        const t = this.querySelector("a");
        t && (window.location.href = t.href);
      }
    }
    handleTouchMove(t) {
      if (!this.touchStarted) return;
      const e = t.touches[0].clientX, o = t.touches[0].clientY, i = Math.abs(e - this.touchStartPos.x), r = Math.abs(o - this.touchStartPos.y);
      (i > this.dragThreshold || r > this.dragThreshold) && (this.isDragging = !0), this.favoriteElement && this.showFavoriteButton();
    }
    handleDocumentTouch(t) {
      this.favoriteElement && (this.contains(t.target) || (this.hideFavoriteButton(), 
      document.removeEventListener("touchstart", this.documentTouchHandler)));
    }
    showFavoriteButton() {
      this.favoriteElement && (this.favoriteElement.style.opacity = "1", this.favoriteElement.style.pointerEvents = "auto");
    }
    hideFavoriteButton() {
      this.favoriteElement && (this.favoriteElement.style.opacity = "0", this.favoriteElement.style.pointerEvents = "none");
    }
    showOutOfStockModal(t) {
      const e = this.querySelector("out-of-stock-form");
      if (e) {
        document.dispatchEvent(new CustomEvent("product-card:show-out-of-stock-modal", {
          detail: {
            variantId: parseInt(t),
            productId: this.dataset.productId
          }
        }));
        const o = e.closest("teleport-details");
        if (o) {
          const t = o.querySelector("details");
          if (t) {
            const e = t.querySelector("summary");
            if (e) e.click(); else {
              const e = t.closest("details-disclosure");
              e && e.close instanceof Function && e.open();
            }
          } else console.error("Details element not found in teleport-details");
        } else console.error("Teleport-details parent not found for out-of-stock modal");
      } else console.error("Out-of-stock modal not found");
    }
    addToCart(t, e) {
      e.setAttribute("data-loading", "true");
      const o = e.innerHTML;
      e.innerHTML = window.strings.adding, r.default.doAdd({
        id: t,
        quantity: 1
      }, !0).then(t => {
        200 === t.status ? e.innerHTML = window.strings.added : e.innerHTML = window.strings.error;
      }).catch(() => {
        e.innerHTML = window.strings.error;
      }).finally(() => {
        setTimeout(() => {
          e.innerHTML = o, e.removeAttribute("data-loading");
        }, 1e3);
      });
    }
    disconnectedCallback() {
      this.documentTouchHandler && document.removeEventListener("touchstart", this.documentTouchHandler);
    }
  }
  customElements.get("product-card") || customElements.define("product-card", n);
}();